// extracted by mini-css-extract-plugin
export default {"budgets":"Budgets_budgets__o-2xg","base":"Budgets_base__DCQxs","header":"Budgets_header__xt3FP","controls":"Budgets_controls__miFLS","buttons":"Budgets_buttons__yN1b5"};